import { App, reportWebVitals } from 'App';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './shared/torq-tools/index.css';
import './Sites/styles/theme-variables.css';
import './vite-fixes.css';

// Set dynamic title and favicon based on company info
const setDynamicBranding = async () => {
  const favicon: any = document.getElementById('favicon');
  let title = 'Sentry';
  let faviconUrl = '/sentry-favicon.ico';

  // Skip API call in local development
  const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  if (isLocalhost) {
    document.title = title;
    favicon.href = faviconUrl;
    return;
  }

  try {
    const currentDomain = window.location.origin;
    const response = await fetch(
      `/api/companies/info-by-domain?domain=${encodeURIComponent(
        currentDomain
      )}`
    );

    if (response.ok) {
      const companyInfo = await response.json();

      // Only override title if company has a logo
      if (companyInfo && companyInfo.hasLogo && companyInfo.name) {
        title = companyInfo.name;
      }
    }
  } catch (error) {
    // If anything fails, keep the default title
    console.log('Could not fetch company info, using default branding');
  }

  document.title = title;
  favicon.href = faviconUrl;
};

// Set branding before rendering the app
setDynamicBranding();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
